let origin = window.ORIGIN;
//设备列表
const getListURL = `${origin}/gateway/hc-device/iot/device/list`;

export { getListURL };
